import type { EngineTourConfig, EngineTourStep } from './tour-engine.types';

export const TRIAL_TOUR_ID = 'trial';
const TRIAL_STORAGE_KEY = 'moderne-tour-trial';

const rawSteps = [
  {
    id: 'trial-recipe-details',
    target: '[data-tour="recipe-details"]',
    route: '/recipes/[recipeId]',
    title: 'This is the recipe you picked',
    content:
      "We've preloaded it with its options, ready to try against a curated sample repository — no setup or repositories of your own required.",
    placement: 'bottom-start' as const,
    skipBeacon: true,
    blockTargetInteraction: true,
    data: { advance: 'next' as const }
  },
  {
    id: 'trial-dry-run',
    target: '[data-tour="dry-run"]',
    route: '/recipes/[recipeId]',
    title: 'Try it on a sample repo',
    content:
      'Click Dry run to safely preview the changes this recipe makes — nothing is modified.',
    placement: 'bottom' as const,
    skipBeacon: true,
    skipScroll: true,
    data: { advance: 'action' as const, backTo: 'trial-recipe-details' }
  },
  {
    id: 'trial-results-progress',
    target: '[data-tour="results-progress"]',
    route: '/results/[organization]/[recipeRunId]',
    title: 'Your recipe is running',
    content:
      "Nice — it's running on the sample repositories. Your results will appear here in a moment.",
    placement: 'bottom-start' as const,
    skipBeacon: true,
    spotlightPadding: 16,
    // Advanced by an effect on the results page watching the real run status,
    // not a manual Next click — the whole point of this step is to reflect
    // what's actually happening, not a fixed pace.
    data: { advance: 'action' as const }
  },
  {
    id: 'trial-results-outcome',
    target: '[data-tour="trial-results-outcome"]',
    route: '/results/[organization]/[recipeRunId]',
    title: "Here's what your run produced",
    content:
      'This area shows the results — whatever happened, the page above already explains it in detail.',
    placement: 'top-start' as const,
    skipBeacon: true,
    data: { advance: 'next' as const }
  }
];

export const trialTourConfig: EngineTourConfig = {
  tourId: TRIAL_TOUR_ID,
  storageKey: TRIAL_STORAGE_KEY,
  highLevelSteps: [{ label: 'Try it out', range: [0, rawSteps.length - 1] }],
  // One phase for the whole tour, but phaseNumber still counts individual
  // steps within it — otherwise every step reads "STEP 1 OF 1" and the
  // tooltip's progress dots never move.
  steps: rawSteps.map((step, index) => ({
    ...step,
    data: {
      ...step.data,
      phaseNumber: index + 1,
      phaseTotal: rawSteps.length,
      phaseLabel: 'Try it out'
    }
  })) as EngineTourStep[]
};
